/* Static posters first: animations start only after a deliberate visitor action. */
if (!customElements.get('ruebloom-editorial-motion')) {
  class RuebloomEditorialMotion extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.image = this.querySelector('[data-motion-image]');
      this.toggle = this.querySelector('[data-motion-toggle]');
      if (!this.image || !this.toggle || !this.dataset.animation) return;
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.playing = false;
      this.toggle.hidden = false;
      this.toggle.addEventListener('click', () => this.setPlaying(!this.playing), { signal });
      this.image.addEventListener('error', () => {
        if (this.playing) this.setPlaying(false);
      }, { signal });
      this.motionPreference.addEventListener('change', () => {
        if (this.motionPreference.matches) this.setPlaying(false);
      }, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.setPlaying(false);
      }, { signal });
      // A section re-render disconnects this element, removes listeners, and resets its replacement.
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(this)) this.setPlaying(false);
      }, { signal });
      this.setPlaying(false);
    }

    setPlaying(playing) {
      if (!this.image || !this.toggle) return;
      this.playing = Boolean(playing);
      const source = this.playing ? this.dataset.animation : this.dataset.poster;
      if (source) {
        this.image.src = source;
        this.image.hidden = false;
      } else {
        this.image.hidden = true;
        this.image.removeAttribute('src');
      }
      this.toggle.setAttribute('aria-pressed', String(this.playing));
      this.toggle.textContent = this.playing ? this.dataset.pauseLabel : this.dataset.playLabel;
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
      this.playing = false;
    }
  }
  customElements.define('ruebloom-editorial-motion', RuebloomEditorialMotion);
}
